import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField,
} from '@mui/material'
import { isClaimServiceLog } from '../../ClaimHistory'

interface LogEntry {
    message: string
    type: 'log'
    logType: string
    status: string
    data: any
}

interface ViewDialogProps {
    entry: LogEntry
    close: () => void
    open: boolean
    // sender
}

const ViewLogDialog = ({ open, close, entry }: ViewDialogProps) => {
    if (!isClaimServiceLog(entry.type) && entry.type !== 'log') {
        return <></>
    }

    return (
        <Dialog open={open} onClose={close} maxWidth="lg">
            <DialogTitle>Details</DialogTitle>
            <DialogContent>
                <Box style={{ display: 'flex', flexDirection: 'column', width: '640px' }}>
                    <TextField
                        label="Message"
                        inputProps={{ readOnly: true }}
                        fullWidth
                        value={entry.message}
                        style={{ marginTop: '20px' }}
                    />
                    <TextField
                        label="Log Type"
                        inputProps={{ readOnly: true }}
                        fullWidth
                        value={entry.logType}
                        style={{ marginTop: '20px' }}
                    />
                    <TextField
                        label="Status"
                        inputProps={{ readOnly: true }}
                        fullWidth
                        value={entry.status}
                        style={{ marginTop: '20px' }}
                    />
                    <TextField
                        label="Content"
                        value={JSON.stringify(entry.data, undefined, 2)}
                        style={{ marginTop: '5px' }}
                        inputProps={{ readOnly: true }}
                        multiline
                        rows={8}
                        fullWidth
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button
                    disableElevation={true}
                    variant="contained"
                    style={{ minWidth: '120px' }}
                    onClick={close}
                >
                    close
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ViewLogDialog
